const riot = require('riot');

riot.tag2('item-remind', '<div class="w-full rounded-8 transition hover-trigger hover-box-shadow focus-box-shadow {getBgColor()}" ondblclick="{onAddReactionEyes}" ontouchstart="{dblTapAddReactionEyes}"> <div class="f w-full p16"> <div class="f ft flex-fixed mr16"><img class="block object-fit-cover circle s40 overflow-hidden" riot-src="{app.utils.getImageUrl(opts.remind.relation.action_user.data.icon_image)}"></div> <div class="w-full overflow-hidden"> <div class="f fm fbw mb8"> <div class="mr4" data-is="atom-project" item="{opts.remind.relation.project}"></div> <div class="f fm gap-16 text-label_dark_medium s-gap-5"> <div class="f fm" if="{getNote().data.end_at}"><i class="icon-time fs16 mr2"></i><span class="flex-fixed fs12 {\'text-alert_primary\' : dayjs(getNote().data.end_at).isBefore(dayjs(),\'date\')}" data-is="atom-time" date="{getNote().data.end_at}"></span></div> <div if="{getNote().data.assigned_user_refs.length}" data-is="atom-assign" note="{getNote()}"></div><span class="flex-fixed font-lato lh15 fs10" data-is="atom-time" date="{opts.remind.data.created_at}"></span> <div class="f fm gap-8 s-gap-5"><i class="icon-reply fs16 cursor-pointer hover-trigger hover-text-background_dark_primary tooltip" onclick="{onToggleComment}" role="button" aria-label="返信" data-tooltip-position="top" data-tooltip-offset-top="0"></i><i class="icon-more_vertical fs16 cursor-pointer hover-trigger hover-text-background_dark_primary tooltip" onclick="{onOpenActionSheet}" role="button" aria-label="メニュー" data-tooltip-position="top" data-tooltip-offset-top="0"></i><i class="icon-fullscreen fs16 cursor-pointer hover-trigger hover-text-background_dark_primary tooltip" onclick="{onOpenNote}" role="button" aria-label="開く" data-tooltip-position="top" data-tooltip-offset-top="0"></i></div> </div> </div> <div class="w-full lh15 line-clamp-2 word-break-all mb8"><span class="bold">@{opts.remind.relation.action_user.data.screen_name}</span><span>が</span><a class="word-break-all bold text-primary" href="/{opts.remind.relation.note.path + &quot;?view=list&quot;}">{opts.remind.relation.note.data.title}</a><span>で</span><span class="bold" each="{mention in opts.remind.relation.message.data.mentions}">{mention}</span><span>に</span><a class="text-primary bold" href="{getMessageLink()}">メンション</a><span>しました。</span></div> <div class="px16 overflow-hidden mxn16 transition mb8" riot-style="max-height:{isOpen ? getMaxHeight() : DEFAULT_HEIGHT}px"> <div class="lh15 text-label_dark_primary word-break-all" ref="content" data-is="atom-markdown" content="{opts.remind.relation.message.data.content}"></div> </div> <div class="f fc" if="{getMaxHeight() &gt; DEFAULT_HEIGHT}"> <button class="button primary f fm px8 py2 border-none transition" onclick="{onToggleOpen}" role="button"> <div class="mr4">{isOpen ? \'閉じる\' : \'全て表示\'}</div><i class="icon-arrow-down fs16 {\'rotate-180\' : isOpen}"></i> </button> </div> <div class="f fm"> <div class="w-full" ref="reactions" data-is="module-message-reactions" item="{opts.remind.relation.message}" verify="{false}"></div> <button class="button primary f fm flex-fixed bg-white h24 pr6 pl3" onclick="{onClickDone}" type="button" if="{!opts.remind.data.done}"><i class="icon-check fs16 mr3"></i> <div class="fs12">完了にする</div> </button> <button class="button dark_light f fm bg-white flex-fixed h24 pr6 pl3" onclick="{onClickRestore}" type="button" if="{opts.remind.data.done}"><i class="icon-cicle-arrow-left fs16 mr3"></i> <div class="fs12">未完了に戻す</div> </button> </div> </div> </div> <div class="border-top" if="{isCommenting}" ref="form" data-is="module-comment-form" mentions="{mentions}" note="{getNote()}" project="{opts.remind.relation.project}"></div> </div>', 'item-remind,[data-is="item-remind"]{display:block}', '', function(opts) {

    this.isCommenting = false;

    this.DEFAULT_HEIGHT = 120;

    this.on('mount', () => {
      requestAnimationFrame(() => {
        this.update();
      });
      this.refs.reactions.on('submit', async (e = {}) => {

        this.look();
        this.refreshMessage();
        if (!e.removed && this.opts.remind.data.type === 'auto') {
          await this.done();
          await this.refreshRemind();
        }
      });
    });

    this.onToggleComment = async () => {

      if (this.isCommenting) {
        this.isCommenting = false;
        this.update();
        return;
      }

      else {
        this.isCommenting = true;
        this.update();
        this.refs.form.setOption('gutters', []);
        this.refs.form.setValue(`@${this.opts.remind.relation.action_user.data.screen_name} `);
        this.refs.form.refs.editor.focus();
        this.refs.form.refs.editor.setCursorToLast();

        this.refs.form.on('commentpost', async ({value}) => {
          this.isCommenting = false;

          await this.look();

          await app.api.child(`${this.getNote().ref.path}/messages`).post({
            content: value,
          });
          spat.toast.message('コメントを送信しました');
          this.update();

          if (this.opts.remind.data.type === 'auto') {
            await this.done();
            await this.refreshRemind();
          }

        })

        this.mentions = await this.opts.remind.relation.project.fetchMentions();

        this.refs.form.focusEditor();
      }
    };

    this.onOpenNote = async () => {
      spat.popup.closeAll();
      let note = this.opts.remind.relation.note;
      if (app.useragent.isMobile) {
        spat.router.push(`/${this.getNote().path}`);
      }
      else {
        let modal = spat.modal.open('modal-note', {
          note: this.getNote(),
        });

        await modal.waitClose();

        this.refreshRemind();
        this.refreshMessage();
      }
    };

    this.isMyReaction = (reactions) => {
      return reactions && reactions.some(item => item.user_ref.id === app.auth.currentUser.uid);
    };

    this.onAddReactionEyes = async () => {
      this.addReaction('Eyes');

      this.look();
    };

    this.dblTapAddReactionEyes = app.utils.handlers.generateDoubleTap(() => {

      this.look();
      this.addReaction('Eyes');
    });

    this.addReaction = async (key) => {
      await this.opts.remind.addReaction(key);
      if (this.opts.remind.data.type === 'auto') {
        await this.done();
        await this.refreshRemind();
      }
    };

    this.refreshRemind = async () => {
      await this.opts.remind.refresh();
      this.update();
    };

    this.refreshMessage = async () => {
      await this.opts.remind.relation.message.refresh();
      this.update();
    };

    this.getNote = () => {
      return this.opts.remind.relation.note;
    };

    this.getMessageLink = () => {
      return '/' + this.opts.remind.data.message_ref.path + `?view=list`;
    };

    this.look = () => {
      return this.opts.remind.look();
    };

    this.onOpenActionSheet = (e) => {
      let options = [
        {
          label: 'お気に入り',
          icon: 'star_empty',
          action: () => { popup.close(); this.favorite(); },
        },
      ];

      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 0,
        align: { x: 'right' },
        position: 'bottom',
        opts: {
          options: options,
        },
      });
    };

    this.favorite = async () => {
      await this.opts.remind.relation.message.favorite();
      spat.toast.message('お気に入りしました');
    };

    this.onToggleOpen = () => {
      this.isOpen = !this.isOpen;
    };

    this.getMaxHeight = () => {
      let content = this.refs.content;
      let height = content.root.scrollHeight;
      return height;
    };

    this.existsScreenName = () => {
      let {screen_name} = app.store.currentUser.data;
      return this.opts.remind.relation.message.data.mentions.some(mention => `@${screen_name}` === mention);
    };

    this.getBgColor = () => {
      if (this.opts.remind.data.done) return "bg-pale";
      return this.existsScreenName() ? 'bg-alert_pale' : 'bg-white';
    };

    this.done = async () => {
      if (this.opts.remind.data.done) return ;
      try {
        await this.opts.remind.done();
      }
      catch (e) {
        console.error(e);
      }
    };

    this.restore = async () => {
      try {

        await this.opts.remind.restore();
      }
      catch (e) {
        console.error(e);
      }
    };

    this.onClickDone = async () => {
      if (!this.opts.remind.relation.message.hasMyReaction()) {

        this.opts.remind.addReaction('Eyes');
        this.opts.remind.look();
      }
      await this.done();
      await this.refreshRemind();
    };

    this.onClickRestore = async () => {
      await this.restore();
      await this.refreshRemind();
    };
});